(() => {
  'use strict';

  if (window.cdlStickyCountdownLoaded) return;
  window.cdlStickyCountdownLoaded = true;

  const selectors = {
    banner: '#samita-banner-81',
    header: '.shopify-section--header',
    promo: '.promotional-bar-rotativa'
  };

  const style = document.createElement('style');
  style.id = 'cdl-sticky-countdown-styles';
  document.head.appendChild(style);

  let banner = null;
  let header = null;
  let promo = null;
  let frame = 0;

  function scheduleUpdate() {
    if (frame) return;

    frame = requestAnimationFrame(() => {
      frame = 0;
      update();
    });
  }

  const resizeObserver = new ResizeObserver(scheduleUpdate);
  const bannerObserver = new MutationObserver(scheduleUpdate);

  function bindElements() {
    const nextBanner = document.querySelector(selectors.banner);
    const nextHeader = document.querySelector(selectors.header);
    const nextPromo = document.querySelector(selectors.promo);

    if (
      nextBanner === banner &&
      nextHeader === header &&
      nextPromo === promo
    ) {
      return;
    }

    resizeObserver.disconnect();
    bannerObserver.disconnect();

    banner = nextBanner;
    header = nextHeader;
    promo = nextPromo;

    [banner, header, promo].filter(Boolean).forEach(element => {
      resizeObserver.observe(element);
    });

    if (banner) {
      bannerObserver.observe(banner, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
    }
  }

  function setRules(css) {
    if (style.textContent !== css) {
      style.textContent = css;
    }
  }

  function update() {
    bindElements();

    if (!banner || !header) {
      setRules('');
      return;
    }

    const bannerStyle = getComputedStyle(banner);
    const bannerRect = banner.getBoundingClientRect();

    const visible =
      bannerStyle.display !== 'none' &&
      bannerStyle.visibility !== 'hidden' &&
      Number(bannerStyle.opacity) !== 0 &&
      bannerRect.height > 0 &&
      bannerRect.width > 0;

    if (!visible) {
      setRules('');
      return;
    }

    const bannerHeight = bannerRect.height;
    const headerHeight = header.getBoundingClientRect().height;

    const bannerId = CSS.escape(banner.id);
    const headerId = CSS.escape(header.id);

    let css = `
      #${bannerId} {
        position: sticky !important;
        top: 0 !important;
        z-index: 10 !important;
      }

      #${headerId} {
        top: ${bannerHeight}px !important;
      }
    `;

    if (promo && getComputedStyle(promo).position === 'sticky') {
      const promoId = CSS.escape(promo.id);

      css += `
        #${promoId} {
          top: ${bannerHeight + headerHeight}px !important;
        }
      `;
    }

    setRules(css);
  }

  // Detecta a inserção ou remoção do banner pelo app.
  const pageObserver = new MutationObserver(scheduleUpdate);

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', scheduleUpdate, {
    passive: true
  });

  window.addEventListener('pageshow', scheduleUpdate);

  document.addEventListener(
    'shopify:section:load',
    scheduleUpdate
  );

  document.addEventListener(
    'shopify:section:unload',
    scheduleUpdate
  );

  scheduleUpdate();
})();
